// src/hooks/useGabaritEquipements.ts — SCE Issues
// Mesure, avec la vraie police, le contenu de chaque colonne de la liste des
// équipements sur tout le référentiel, puis en tire la grille
// (`utils/largeursEquipements`). Même mesure que le tableau « Tous les
// problèmes » (`useLargeursAuto`) ; recompte quand la police self-hostée arrive.

import { useEffect, useMemo, useState } from 'react'
import { mesurerTexte } from '@/hooks/useLargeursAuto'
import { executionDe, resumeCaracteristiques, type EquipementLu } from '@/utils/filtresEquipements'
import { gabaritEquipements, plusLarge } from '@/utils/largeursEquipements'

// Tailles des cellules denses (globals.css) : texte 14 px, secondaire 12 px.
const TEXTE = 14
const SECONDAIRE = 12
/** Clé 13 px + écart 5 + marges 6 et 8 autour du mot (BadgeFabrication). */
const HABILLAGE_BADGE = 13 + 5 + 6 + 8
/** Les morceaux en gras des caractéristiques élargissent un peu la ligne. */
const MARGE_GRAS = 1.04
/** Chiffres tabulaires (N° de série, OF) : un peu plus larges que la mesure du canvas. */
const MARGE_CHIFFRES = 1.06

export function useGabaritEquipements(lus: readonly EquipementLu[], avecFabrication: boolean): string {
  const [policesPretes, setPolicesPretes] = useState(0)
  useEffect(() => {
    let annule = false
    void document.fonts?.ready.then(() => {
      if (!annule) setPolicesPretes((n) => n + 1)
    })
    return () => {
      annule = true
    }
  }, [])

  return useMemo(() => {
    void policesPretes
    const largeur = (textes: (string | null | undefined)[], taille: number, graisse = 400): number =>
      plusLarge(textes.filter((t): t is string => !!t).map((t) => mesurerTexte(t, taille, graisse)))
    const e = lus.map((l) => l.equipement)
    return gabaritEquipements({
      numeroSerie: largeur(e.map((x) => x.numeroSerie), TEXTE, 500) * MARGE_CHIFFRES,
      fabrication: avecFabrication ? mesurerTexte('En fabrication', SECONDAIRE, 500) + HABILLAGE_BADGE : null,
      modele: largeur(e.map((x) => x.familleEquipement || '—'), TEXTE),
      execution: largeur(lus.map(executionDe), SECONDAIRE),
      caracteristiques:
        largeur(lus.map((l) => resumeCaracteristiques(l).map((m) => m.texte).join(' · ')), SECONDAIRE) * MARGE_GRAS,
      of: largeur(e.map((x) => x.of || '—'), SECONDAIRE) * MARGE_CHIFFRES,
      chef: largeur(e.map((x) => x.chefProjet), SECONDAIRE),
    })
  }, [lus, avecFabrication, policesPretes])
}
